// extracted by mini-css-extract-plugin
module.exports = {"EditCourse":"EditCourse_EditCourse__2cI7i","EditCourseMenu":"EditCourse_EditCourseMenu__3T9TA","LeftSidePopupContainer":"EditCourse_LeftSidePopupContainer__hfn-9"};